export default __webpack_public_path__ + "static/media/bg.d63cfd51.png";